import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type { ListConnectableInstallationsResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const fetchGitHubAppConnectCandidates = (app: VcsApp) =>
  get<ListConnectableInstallationsResponse>(`/api/vcs/github-apps/${app}/connect/candidates`);

export const getGitHubAppConnectCandidatesQueryKey = (app: VcsApp) =>
  ['vcs', 'github-apps', app, 'connect', 'candidates'] as const;

/**
 * Lists the installations the user's GitHub account can access, found when they came back from
 * GitHub authorization. Empty until that round trip has happened in this session.
 */
export function useGitHubAppConnectCandidates(app: VcsApp, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: getGitHubAppConnectCandidatesQueryKey(app),
    queryFn: () => fetchGitHubAppConnectCandidates(app),
    enabled,
  });
}
